/**
 * Google Analytics tracking utilities
 */

/**
 * Track form submission events
 * @param {string} formName - Name/ID of the form
 * @param {Object} additionalParams - Additional parameters to track
 */
export const trackFormSubmission = (formName, additionalParams = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'form_submission', {
      form_name: formName,
      page_path: window.location?.pathname,
      page_location: window.location?.href,
      ...additionalParams
    });
  }
};

/**
 * Track catalog download events
 * @param {string} catalogType - Type of catalog downloaded
 * @param {Object} userInfo - User information from form
 */
export const trackCatalogDownload = (catalogType, userInfo = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'catalog_download', {
      catalog_type: catalogType,
      page_path: window.location?.pathname,
      page_location: window.location?.href,
      user_email: userInfo?.email || '',
      user_company: userInfo?.company || '',
      ...userInfo
    });
  }
};

/**
 * Track button click events
 * @param {string} buttonName - Name/ID of the button
 * @param {Object} additionalParams - Additional parameters to track
 */
export const trackButtonClick = (buttonName, additionalParams = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'button_click', {
      button_name: buttonName,
      page_path: window.location?.pathname,
      page_location: window.location?.href,
      ...additionalParams
    });
  }
};

/**
 * Track custom events
 * @param {string} eventName - Name of the event
 * @param {Object} params - Event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, {
      page_path: window.location?.pathname,
      page_location: window.location?.href,
      ...params
    });
  }
};

/**
 * Track lead generation events
 * @param {string} leadType - Type of lead (contact, service_request, etc.)
 * @param {Object} leadInfo - Lead information
 */
export const trackLeadGeneration = (leadType, leadInfo = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'generate_lead', {
      lead_type: leadType,
      page_path: window.location?.pathname,
      page_location: window.location?.href,
      ...leadInfo
    });
  }
};
